export const visit = (vm, at) => {
vm(require("property-management-iframe/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
vm(require("marketplace-unified-public-base/lang/en.lyaml"));
vm(require("marketplace-storefront-base/lang/en.lyaml"));
vm(require("ui-universal-auth/lang/en.lyaml"));
at({ "en": { "marketplaceStorefrontPublicUi": { "hello": "world" } } });
};